import type { AddFundMergeCommandData } from '@festina/unitlink-general-types/unitlink'
import { FundSourcesCommandsService } from '@festina/unitlink-general-types/unitlink/services/FundSourcesCommandsService'
import { useFestinaMutation } from '@festina-life/authentication'

import type { FundActionProps } from '../types'

const method = FundSourcesCommandsService.fundSourcesServicePostCommands

export const useAddFundMerge = ({ tenantId, isinKey }: FundActionProps) =>
  useFestinaMutation({
    component: 'unitLink',
    roles: FundSourcesCommandsService.fundSourcesServicePostCommands_roles,
    isScenario: false,
    mutateFunction: async (arg: AddFundMergeCommandData) => {
      await method({
        xTenantId: tenantId,
        isinKey,
        requestBody: {
          _type: 'CreateFundCommand',
          commandType: 'addFundMerge',
          commandData: arg,
        },
      })
    },
  })
